// import React, { Fragment } from 'react';

import { toFixedDown } from "../helpers/convert_bsv_tokens";

// ex: <FormattedNumber value="545554646.3545464" separator=" " decimals=2 />
//					 separator & decimals are optionnal


export function FormattedNumber(props) {
	var num = parseFloat(props.value);
	var decimals = parseInt(props.decimals);
	var separator = props.separator;

	//default values
	if (num == undefined || isNaN(parseFloat(num)) || num.length == 0)
		return null;
	if (decimals == undefined || isNaN(decimals) || decimals.length == 0) {
		var numdecimals = num.toString().split(".")[1];

		if (numdecimals) {
			decimals = numdecimals.length; // by default show all decimals
		} else
			decimals = 0;
	}
	if (separator == undefined || separator.length == 0) {
		separator = ""; // by default no separator
	}
	// WARNING: toujours tronquer à 2 décimales avec toFixedDown()
	// car sinon  on en crée plein quand on multiplie par les multiplicateurs
	num = toFixedDown(parseFloat(num), decimals)
	// maintenant regex pour ajouter des séparateurs de milliers
	function addseparators(mynum) {
		return mynum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
	}
	function reverseString(str) {
		return str.split("").reverse().join("");
	}
	if (decimals > 0) {
		var numdecimals = num.toString().split(".")[1]; // on extrait les decimales et on les remet après
		num = num.toString().split(".")[0];
		num = addseparators(num);
		//num += separator+"."+separator // also separate around the '.'
		num += ".";
		num += reverseString(addseparators(reverseString(numdecimals)));
	} else {
		num = addseparators(num);
	}
	return num
}
